import WAMP from './WAMP';

(() => {
	let wampInstance = WAMP.getInstance();

	window.wamp = {
		instance: wampInstance,
		subscribe: (topic, callback) => {
			wampInstance.subscribe(topic, callback);
		},
		connected: (callback) => {
			wampInstance.connected(callback);
		},
		publish: (topic, args, kwargs) => {
			wampInstance.publish(topic, args, kwargs);
		},
		unsubscribe: (topic) => {
			wampInstance.unsubscribe(topic);
		},
		onclose: (callback) => {
			wampInstance.onclose(callback);
		}
	};
})();
